/**
 * Shared spacing-token names + px lookup for layout primitives.
 *
 * Derived from `tokens/semantic/spacing.json` so any change in tokens
 * flows here automatically. `none` is included as a UI escape hatch
 * (no design-token equivalent — just zero).
 *
 * @format
 */

import spacingTokens from 'ui/tokens/semantic/spacing.json';

export const SPACING_TOKEN_NAMES = [
  'none',
  'tight',
  'xxs',
  'xs',
  'xs-plus',
  's',
  's-plus',
  'm',
  'm-plus',
  'l',
  'l-plus',
  'xl',
] as const;
export type SpacingTokenName = (typeof SPACING_TOKEN_NAMES)[number];

function px(value: string): number {
  const n = parseInt(value);
  return Number.isFinite(n) ? n : 0;
}

const PX: Record<SpacingTokenName, number> = {
  none: 0,
  tight: px(spacingTokens.spacing.tight.$value),
  xxs: px(spacingTokens.spacing.xxs.$value),
  xs: px(spacingTokens.spacing.xs.$value),
  'xs-plus': px(spacingTokens.spacing['xs-plus'].$value),
  s: px(spacingTokens.spacing.s.$value),
  's-plus': px(spacingTokens.spacing['s-plus'].$value),
  m: px(spacingTokens.spacing.m.$value),
  'm-plus': px(spacingTokens.spacing['m-plus'].$value),
  l: px(spacingTokens.spacing.l.$value),
  'l-plus': px(spacingTokens.spacing['l-plus'].$value),
  xl: px(spacingTokens.spacing.xl.$value),
};

export function spacingPx(token: SpacingTokenName): number {
  return PX[token];
}
